// extracted by mini-css-extract-plugin
module.exports = {"container":"_2cm3mZ_","pill":"_2Ozs2z5"};